import { CATEGORY_LABELS, SERVICE_CATEGORIES, type ServiceCategory } from '@makhe/shared';
import { cn } from '@/lib/cn';

interface Props {
  value: ServiceCategory[];
  onChange: (next: ServiceCategory[]) => void;
  multiple?: boolean;
}

export function CategoryPicker({ value, onChange, multiple = true }: Props) {
  const toggle = (c: ServiceCategory) => {
    if (multiple) {
      onChange(value.includes(c) ? value.filter((v) => v !== c) : [...value, c]);
    } else {
      onChange([c]);
    }
  };
  return (
    <div className="flex flex-wrap gap-2">
      {SERVICE_CATEGORIES.map((c) => {
        const selected = value.includes(c);
        return (
          <button
            key={c}
            type="button"
            onClick={() => toggle(c)}
            className={cn(
              'rounded-full border px-4 py-1.5 text-[11px] uppercase tracking-widest transition-colors',
              selected
                ? 'border-makhe-ink bg-makhe-ink text-makhe-bg'
                : 'border-makhe-line bg-transparent text-makhe-ink hover:border-makhe-ink',
            )}
          >
            {CATEGORY_LABELS[c]}
          </button>
        );
      })}
    </div>
  );
}
